import { PricingTier } from '@/pages/unauthenticated/pricing/components/types';
import { cn } from '@/lib/utils';

export const TierHeader = ({ tier }: { tier: PricingTier }) => (
  <div aria-hidden="true" className="-mt-px">
    <div
      className={cn('border-t-2 pt-10 border-transparent', {
        'border-primary': tier.featured,
      })}
    >
      <p
        className={cn('text-sm font-semibold leading-6', {
          'text-primary': tier.featured,
        })}
      >
        {tier.name}
      </p>
      <p className="mt-1 text-sm leading-6">{tier.description}</p>
    </div>
  </div>
);
